import querystring from 'query-string'

import type { LiveEventExamplesSearchParamSource } from '../hooks/useLiveEventExamplesSearchParams'

const liveEventExamplesSearchParamKeys: (keyof LiveEventExamplesSearchParamSource)[] = [
  'gameIds',
  'liveEventTags',
  'liveEventSecondaryTags',
  'motivations',
  'archetypes',
  'liveEventAppearances',
  'dateFrom',
  'dateTo',
  'groupBy',
  'hideDiscontinuedBlueprints',
]

const querystringOptions = { arrayFormat: 'comma' as const }

/**
 * Live Event Examples keeps its filters, date range and toggles in the URL, using
 * the same keys the Live Events tab reads. Removes them from a search string so
 * the Live Event Examples selections don't carry over to another tab.
 * Any other params (e.g. modal params) are kept.
 */
export const removeLiveEventExamplesSearchParams = (search: string): string => {
  const parsed = querystring.parse(search, querystringOptions)
  liveEventExamplesSearchParamKeys.forEach((key) => delete parsed[key])
  const remaining = querystring.stringify(parsed, querystringOptions)

  return remaining ? `?${remaining}` : ''
}
